<script setup>
defineProps({
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>

<template>
  <div :class="[backgroundColor === 'black' ? 'white' : 'black']">
    <p
      v-if="title && title.length > 0"
      class="insurance-program__title h3 mb-0"
      v-html="title"
    ></p>
    <div
      v-if="description && description.length > 0"
      class="insurance-program__description body-1-regular"
      v-html="description"
    ></div>
  </div>
</template>
<style scoped lang="scss">
.insurance-program {
  &__title {
    margin: 0;
  }
  &__description {
    &:deep(p:first-child) {
      margin: 0;
    }
    @include media-breakpoint-up(md) {
      max-width: 71.5%;
    }
  }
}
</style>
